<template>
  <div>
      <div class="px-6 py-4" v-if="!is_edvisor">
          <div class="flex cursor-pointer" @click="clearFilters()">
              <feather-icon icon="LayersIcon" svgClasses="h-6 w-6"></feather-icon>
              <span class="text-lg-center ml-3">{{$t('show_all')}}</span>
          </div>
      </div>
      <div class="px-6 pb-2 flex flex-col select-class"  style="    height: max-content;">
          <div >
              <div class="flex  my-1" >
                  <div class="w-full">
                      <p class="required text-primary" style="font-weight: 500;">
                          {{ $t('choose_an_academic_year') }}
                      </p>
                      <Select
                          v-model="filter['study_year']"
                          :placeholder="$t('study_year')"
                          noOptions="no_data_text"
                          name="study_year"
                          noResult="not_search_result"
                          apiType="study_years"
                          apiPath="common/"
                          :disabled="is_edvisor"
                          :max-height="170"
                          deselectLabel=""
                          trackBy="uid"
                          :customLabel="StudyYearLabel"
                          @input='selectedFun($event)'
                      />
                  </div>
              </div>

              <div class="flex  my-1">
                  <div class="w-full">
                      <p class=" required text-primary" style="font-weight: 500;">
                          {{ $t('Choose_a_curriculum') }}
                      </p>
                      <Select
                          v-model="filter['study_plan']"
                          :placeholder="$t('study_plan')"
                          noOptions="no_data_text"
                          name="study_plan"
                          noResult="not_search_result"
                          apiType="my_study_plans_version2"
                          :max-height="170"
                          apiPath="user/"
                          trackBy="uid"
                          deselectLabel=""
                          :disabled="is_edvisor"
                          :customLabel="StudyPeriodLabel"
                          @input='selectedFun($event)'
                      />
                  </div>
              </div>
              <div class="flex  my-1">
                  <div class="w-full">
                      <p class=" required text-primary" style="font-weight: 500;">
                          {{ $t('Choose_an_academic_period') }}
                      </p>
                      <Select
                          v-model="filter['acad_period']"
                          :placeholder="$t('acad_periods')"
                          noOptions="no_data_text" name="acad_period"
                          noResult="not_search_result"
                          apiType="acad_periods_for_reg/copy"
                          apiPath="common/"
                          :max-height="170"
                          trackBy="uid"
                          :customLabel="AcadPeriodLabel"
                          deselectLabel=""
                          :disabled="is_edvisor"
                          @input='selectedFun($event)'
                      />
                  </div>
              </div>
              <div class="flex my-2" >
                  <div class="w-full">
                      <vs-button type="border" :disabled="SelectedAll||is_edvisor" text-color="#7367F0" @click="fetchCicle()"   class="w-full" >
                          {{$t("apply")}}
                      </vs-button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import Select from './Select.vue'
import CycleMixin from './DisList/CycleMixin.vue';
import CounterMixin from './DisList/CounterMixin.vue'
import ModalRequestMixin from "./DisList/ModalRequestMixin";
import { mapActions, mapGetters, mapMutations } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
    name: "Filters",
    mixins:[CycleMixin,CounterMixin,ModalRequestMixin],
    components: {Select,VuePerfectScrollbar},
    data() {
        return {

            is_ready:false,
            filter: {
                study_year: null,
                study_plan: null,
                acad_period: null
            },
            data:[],
            scrool_active:false

        }

    },
    watch: {
        filter: {
            handler: function (val) {
                this.filter_watch(val)
            },
            deep: true
        },
    },

    computed: {

        SelectedAll(){
            var view = false;
            // console.log('before SelectedAll: ',this.filter);

            this.$_.each(this.filter, function (e, i) {
                if(e == null){
                    view = true
                }
            });

            return view
        },
        is_edvisor(){
            return this.$store.state.user.user.role.is_supervisor
        },
        ...mapGetters({
            obj: "ApplicationForISC/application"
        }),
        student(){
            if (this.is_edvisor){
                return this.$route.query.student
            }else{
                return this.$store.state.user.user.profileId
            }
        },
    },
    async created() {
        if(this.is_edvisor){
            await this.fetchCicle()
        }
    },
    methods: {
        ...mapActions({
            CREDIT_LIMIT_SYSTEM:'regis_discepline/CREDIT_LIMIT_SYSTEM',
            getStudyPeriod: "organizations/getStudyPeriod",
            getAcadPeriod: "organizations/getAcadPeriod",
            STATUS_INFO: "regis_discepline/STATUS_INFO",
            getStudyPlan: "organizations/getStudyPlan",
        }),
        ...mapMutations({
            CLEAR_COMPONENTS_CYCLE:'regis_discepline/CLEAR_COMPONENTS_CYCLE'
        }),
        async selectedFun(val){
            this.is_ready = await val.con
            if (val.name == "study_year"){
                this.filter[`${ val.name }`] = val.select
                if (!this.$route.query.study_plan){
                    this.$http.get('user/my_study_plans_version2/').then((response)=>{
                        if (response.data.length == 1){
                            this.filter.study_plan = response.data[0]
                        }
                    })
                }
            } else{
                this.filter[`${ val.name }`] = val.select
            }

        },

        StudyYearLabel(item) {
            return item ? `${ item.start } - ${ item.end }`:'Без наименований'
        },

        StudyPeriodLabel(item) {
            return item.education_program ?`${ item.education_program.name } `: 'Без наименований'
        },

        AcadPeriodLabel(item) {
            return item ?`${ item.name } `: 'Без наименований'
        },

        async fetchCicle(){
            try {
                if(!this.is_edvisor){
                    await this.CREDIT_LIMIT_SYSTEM()
                }
                var params = {}
                if(this.is_edvisor){

                    if (this.obj.acad_periods){

                        this.filter.study_year = await this.getStudyPeriod(this.obj.study_year);
                        this.filter.study_plan = typeof(this.obj.study_plan) == 'string' ? await this.getStudyPlan(this.obj.study_plan) : this.obj.study_plan;
                        this.filter.acad_period = await this.getAcadPeriod(this.obj.acad_periods[0].uid);
                        this.filter.student = this.obj.student.profileId;
                        var reg = this.obj.reg_period;

                        params = {
                            study_year:this.obj.study_year,
                            study_plan:this.obj.study_plan,
                            acad_period: this.obj.acad_periods[0].uid,
                            student:this.obj.student.profileId
                        }
                        this.$router.replace({query:
                                    {
                                        study_year:this.obj.study_year,
                                        study_plan:this.obj.study_plan,
                                        acad_period: this.obj.acad_periods[0].uid,
                                        student:this.obj.student.profileId,
                                        reg_period: this.obj.reg_period
                                    }
                        })
                    }else{
                        this.cycles = null
                        var route = this.$route.query

                        this.filter.study_year = route.study_year
                        this.filter.study_plan = await this.getStudyPlan(route.study_plan);
                        this.filter.acad_period = await this.getAcadPeriod(route.acad_period);
                        this.filter.student = route.student
                        params = {
                            study_year:route.study_year,
                            study_plan:route.study_plan,
                            acad_period: route.acad_period,
                            student:route.student
                        }
                    }

                }else{
                    params = {
                        study_year:this.filter.study_year.uid,
                        study_plan:this.filter.study_plan.uid,
                        acad_period:this.filter.acad_period.uid
                    }
                }
                this.$vs.loading();
                await this.$http.get('user/cycle_student_discipline_views/', {
                    params: params}).then(res=>{
                    if(res.data.data.length){
                        this.$store.commit('regis_discepline/SET_CICLE',res.data.data)


                        if (res.data.data[0].short_name == 'ИА'){
                            this.fetchComponent(res.data.data[0].cycle,true);
                        }else {
                            this.fetchComponent(res.data.data[0].cycle,false);
                        }
                        // console.log(res.data.data[0].name)
                    }
                    this.scrool_active = true
                })
                // console.log(params)
                await this.getMaxAndMin()
                await this.STATUS_INFO({...this.$route.query})
                this.$emit("dataSET",this.data);
                this.$emit("click", this.calcDate());

            } catch(e) {
                console.log(e)
            } finally {
                this.$vs.loading.close()
            }
        },
        calcDate() {
            let nowDate = new Date()
            nowDate = nowDate.toISOString().split('T')[0];

            let selectDate = new Date(this.filter.acad_period.end_date)
            selectDate = selectDate.toISOString().split('T')[0];

            if(selectDate >= nowDate) return true
            else return false
        },
        filter_watch(val){
            this.CLEAR_COMPONENTS_CYCLE()
            let fils = {};
            this.$_.each(val, function (e, i) {
                if (e) {
                    fils[i] = e.uid
                }
                if (i == 'student'){
                    fils[i] = e
                }
            });
            this.$store.commit('regis_discepline/SET_FILTER',this.$_.clone(val));
            if(this.is_ready){
                this.$router.replace({query:fils})
            }
        },
        clearFilters() {
            // Очищаем фильтры
            this.filter = {
                study_year: null,
                study_plan: null,
                acad_period: null
            };
        },

    }

}
</script>

<style scoped lang="scss">
.required {
    &::after {
        content: "*";
        color: rgba(var(--vs-danger), 1);
        display: inline-block;
        margin-left: 3px;
    }
}
.select-class{
    height: max-content;
}
.multiselect__content-wrapper{
    max-height: 170px;
}

</style>
